import React from 'react';
import {Field, FormSection, reduxForm} from "redux-form";
import WrapWithLoader from "./WrapWithLoader";

const JOB_TYPES = [
  'Server',
  'Cook',
  'Barista',
  'Bartender',
];

const validate = (values) => {
  const errors = {};

  if (!values.jobs || JOB_TYPES.filter((jobType) => {
      if (!values.jobs[jobType]) return false;
      return values.jobs[jobType].experience !== 'No Experience';
    }).length === 0) {
    errors._error = 'Please enter experience for at least one type of job';
  }

  return errors;
};

function ProSignUpPart2Form(props) {
  const {valid, submitting, handleSubmit} = props;

  return (
    <form id="part2-experience" onSubmit={handleSubmit}>
      <div className="row justify-content-center">
        <div className="col-md-12 col-lg-6">
          <h2>Experience</h2>
        </div>
      </div>
      {/* Work History */}
      <div id="work-history" className="form-section">
        <div className="row justify-content-center header">
          <div className="col-md-12 col-lg-6">
            <h4>Work History</h4>
          </div>
        </div>
        <FormSection name="jobs">
          {JOB_TYPES.map((job) => (
            <React.Fragment key={job}>
              <div className="row justify-content-center">
                <div className="col-md-12 col-lg-6">
                  <h4 className="jobTitle">{job}</h4>
                  {/*<Field component="input" className="inputJobType" name={`${job}.inputJobType`} type="hidden"/>*/}
                </div>
              </div>
              <div className="row justify-content-center">
                <div className="col-md-12 col-lg-6">
                  <div className="form-group">
                    <label htmlFor="InputName">Amount of Experience</label>
                    <Field component="select" className="custom-select inputExperience form-control"
                           name={`${job}.experience`}>
                      <option value="No Experience">No Experience</option>
                      <option value="Less than 3 months">Less than 3 months</option>
                      <option>3 to 6 months</option>
                      <option>6 to 12 months</option>
                      <option>More than 12 months</option>
                    </Field>
                  </div>
                </div>
              </div>
              <div className="row justify-content-center">
                <div className="col-md-12 col-lg-6">
                  <div className="form-group">
                    <label htmlFor="InputName">Places Worked</label>
                    <Field component="input" type="text" name={`${job}.placesWorked`}
                           className="inputPlacesWorked form-control"/>
                  </div>
                </div>
              </div>
            </React.Fragment>
          ))}
        </FormSection>

      </div>
      {/* Submit */}
      <div className="row justify-content-center">
        <div className="col-md-12 col-lg-6">
          <input type="hidden" name="utm_source" value="{{ utm_source }}"/>
          <input type="hidden" name="utm_medium" value="{{ utm_medium }}"/>
          <input type="hidden" name="utm_campaign" value="{{ utm_campaign }}"/>
          <input type="hidden" name="utm_term" value="{{ utm_term }}"/>
          <input type="hidden" name="utm_content" value="{{ utm_content }}"/>
          <WrapWithLoader loading={submitting}>
            <button type="submit" id="submitSignUp" className="btn btn-primary btn-xlg btn-block btn-pointer"
                    disabled={!valid || submitting}>
              Submit
            </button>
          </WrapWithLoader>
        </div>
      </div>
    </form>

  )
}


export default reduxForm({
  form: 'proSignUpPart2Form',
  validate,
})(ProSignUpPart2Form);




// WEBPACK FOOTER //
// ./src/parts/ProSignUpPart2Form.js